import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EdTreatmentUpsell } from '@data/tests';
import { Gender } from '@enums/gender';
import { environment } from '@environments/environment';
import { EdTreatmentResponse } from '@models/ed-treatment-response';
import { StorageService } from '@services/storage.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EdTreatmentService {
  private readonly http = inject(HttpClient);
  private readonly storage = inject(StorageService);

  /**
   * Fetches the ED treatment content from the public API.
   *
   * @returns {Observable<EdTreatmentResponse>} an Observable of the EdTreatmentResponse
   */
  public getContent(): Observable<EdTreatmentResponse> {
    return this.http
      .get(`${environment.analyteCareApi}/api/v2/public-files/ed-treatment.json`, {
        responseType: 'text',
      })
      .pipe(map((responseText) => JSON.parse(responseText)));
  }

  /**
   * Determines whether the ED treatment upsell should be offered to the current user.
   *
   * @returns {boolean} true if the user is male and the site supports the ED treatment upsell
   */
  public shouldOfferUpsell(): boolean {
    return (
      this.storage.order?.gender === Gender.Male &&
      environment.consultation.offersEdTreatmentUpsell &&
      !this.storage.orderedTests.some((test) => test.id === EdTreatmentUpsell.id)
    );
  }
}
